import { useResponsiveClientValue as reUseResponsiveClientValue } from 'reshaped';
import { ResponsiveOnly } from 'reshaped/types/global';

export const useResponsiveClientValue = <T>(value: ResponsiveOnly<T>) => {
  return reUseResponsiveClientValue(value);
};
